module.exports = __webpack_public_path__ + "static/dsc-0837@2x-3d575e7d58cee4e89a70cb6071c8bef9.png";